<template>
    <div class="no-data">
        <img :src="nullBg" alt="">
        <p class="no-data-tip">暂无数据</p>
    </div>
</template>

<script>
  export default {
    name: "no-data",
    data(){
      return {
        nullBg: 'http://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/kzp/template/1565660656-4465.png'
      }
    },
    beforeMount(){
      this.$util.tansPics(this, 'nullBg', {})
    }
  }
</script>

<style scoped>
  img{
    width: 92px;
    height: 92px;
  }
</style>